<template>
  <div>
    <div class="sidenav-container">
      <!-- Sidenav for settings -->
      <div class="sidenav">
        <SettingsLayout active="CustomerStatement"></SettingsLayout>
      </div>
      <!-- General settings content -->
      <div
        class="sidenave-main-content"
        style="padding:0 !important;margin-top:-6px;overflow-y:hidden"
      >
        <b-row class="px-3 border-bottom">
          <b-col cols="12" class="px-0">
            <h2
              class="custom-page-title mb-2 mt-1 px-4"
              style="position:relative;bottom:4px;"
            >Customer</h2>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block pb-4"
          style="padding-left:0 !important;padding-right:0 !important;height: calc(100vh - 92px)"
        >
          <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-1 border-tab">
            <b-tab title="General" active class="p-3">
              <b-row>
                <b-col xl="12" lg="12" md="12" xs="12" sm="12">
                  <div class="container-fluid">
                    <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
                      <p class="fw-semi-bold">{{ message }}</p>
                    </b-alert>
                  </div>
                </b-col>
              </b-row>
              <b-form @submit.prevent="onSubmit">
                <b-row>
                  <b-col>
                    <p class="text-muted fw-semi-bold">Duplicate Customer Name</p>
                    <b-form-checkbox
                      plain
                      :true-value="1"
                      :false-value="0"
                      v-model.trim="field.allow_duplicate_cus"
                      class="mt-2 mb-3"
                    >Allow duplicate Customer names</b-form-checkbox>
                  </b-col>
                </b-row>
                <hr align="left" />
                <b-row>
                  <b-col>
                    <p class="text-muted fw-semi-bold">Customer Credit Limit</p>
                    <small
                      class="text-muted"
                    >Credit Limit enables you to set limit on the outstanding receivable amount of the customers.</small>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <b-form-group>
                      <b-form-checkbox
                        :value="1"
                        :unchecked-value="0"
                        v-model="field.cus_credit_limit.enable"
                      >Enable Credit Limit</b-form-checkbox>
                    </b-form-group>
                    <template v-if="field.cus_credit_limit.enable==1">
                      <b-form-group class="ml-4 border-left">
                        <h6 class="m-0 pl-3">What do you want to do when credit limit is exceeded?</h6>
                        <b-form-radio-group
                          class="pl-3 mt-3"
                          v-model="field.cus_credit_limit.restrict"
                          stacked
                        >
                          <b-form-radio
                            :value="1"
                            class="my-1"
                          >Restrict creating or updating invoices</b-form-radio>
                          <b-form-radio
                            :value="0"
                            class="my-1"
                          >Show a warning and allow users to proceed</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>

                      <small>
                        Note:
                        <ul class="text-muted ml-4" style="list-style:circle">
                          <li>Go to the respective customer's contact details to set the credit limit.</li>
                          <li>Credit Limit will not affect recurring invoices.</li>
                        </ul>
                      </small>
                    </template>
                  </b-col>
                </b-row>
                <div class="footer sidenav-footer" style="box-shadow:0 -4px 5px -3px #ccc;">
                  <div class="form-action" style="background:none !important;">
                    <b-button
                      type="submit"
                      size="sm"
                      variant="primary"
                      class="btn-rounded mr-3"
                      :disabled="submitted"
                      @click="general_settings=true"
                    >
                      <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
                    </b-button>
                  </div>
                </div>
              </b-form>
            </b-tab>
            <b-tab title="Field Customization" class="p-0 pt-2" @click="fetchCustomList()">
              <CustomFieldSettings
                v-on:handledelete="handledelete"
                v-on:onSubmit="customsubmit"
                custom_prefix="customer_"
                :custom_field="custom_field"
                :max_count="max_count"
                :used_count="used_count"
                v-on:ConfigureSubmit="configureSubmit"
                :stg_menu="stg_menu"
              />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomFieldSettings from "@/components/Form/Settings/CustomField";
import SettingsLayout from "@/components/Layout/SettingsLayout";
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
export default {
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: { SettingsLayout, CustomFieldSettings },
  data() {
    return {
      index_value: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,

      error_show: false, // to show the error message
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      submitted: false,
      allow_duplicate_cus: "",
      cus_credit_limit: {
        incl_sales: 0,
        enable: 0,
        restrict: 0
      },
      update_id: "",
      general_settings: false,
      stg_menu: "Customer",
      remaining_fields: ""
    };
  },
  methods: {
    fetchCustomList() {
      this.$store.dispatch("settings/fetchCustomList", {
        stg_menu: "Customer"
      });
    },
    configureSubmit(ev) {
      var data = JSON.stringify({
        id: ev.id,
        stg_menu: "Customer",
        app_id: process.env.VUE_APP_APP_ID,
        permissions: ev.permissions
      });
      this.$store
        .dispatch("settings/configureAccessUpdate", data)
        .then(response => {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.code == 200 ? "success" : "danger",
            showCloseButton: true
          });
          if (response.status == 200) {
            this.fetchCustomList();
            this.$store.state.permission.cus_settings_details.custom_field =
              response.data.custom_field;
          }
        });
    },
    handledelete(ev) {
      var data = JSON.stringify({
        id: ev.index_value,
        stg_menu: "Customer",
        table_name: "cbs_cus_tbl_mas_usr_main"
      });
      this.$store.dispatch("settings/postdelete", data).then(() => {
        this.fetchCustomList();
        this.$router.push({
          name: this.$route.name,
          query: {
            update:
              this.$route.query.update || this.$route.query.update == true
                ? false
                : true
          }
        });
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: this.message,
          type: this.code == 200 ? "success" : "danger",

          showCloseButton: true
        });
      });
    },

    removeRow(index) {
      if (this.custom_field.length > 1) {
        this.custom_field.splice(index, 1);
      }
    },
    async customsubmit(ev) {
      if (ev.custom_field == 1) {
        //this.field.index = ev.index;
        //this.field.custom = true;
        this.remaining_fields = ev.remaining_fields;
        this.field.field = ev.custom_data;
        this.update_id = ev.update_id;
        this.general_settings = false;

        //this.field.page = ev.page;
        await this.settingsdata();
      }
    },
    settingsdata() {
      if (this.general_settings) {
        var data = {
          field: this.field,
          stg_menu: "Customer",
          table_name: "cbs_cus_tbl_mas_usr_main"
        };
        this.$store.dispatch("settings/invoice", data).then(result => {
          if (result.status == 201) {
            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: result.data.status,
              type: "danger",
              showCloseButton: true
            });
            return;
          }
          this.page = "";
          this.$router.push({
            name: this.$route.name,
            query: {
              update:
                this.$route.query.update || this.$route.query.update == true
                  ? false
                  : true
            }
          });
          //  code for notificatin display
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: result.data.status,
            type: "success",
            showCloseButton: true
          });
        });
      } else {
        var data = {
          field: this.field.field,
          remaining_fields: this.remaining_fields,
          stg_menu: "Customer",
          table_name: "cbs_cus_tbl_mas_usr_main"
          // custom_field: this.custom_field
        };

        if (this.page == "create") {
          this.$store
            .dispatch("settings/customfieldcreate", data)
            .then(result => {
              if (result.status == 201) {
                //  code for notificatin display
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: result.data.status,
                  type: "danger",
                  showCloseButton: true
                });
                return;
              }
              if (result.status == 200) {
                this.$store.state.permission.cus_settings_details.custom_field =
                  result.data.custom_field;
                this.fetchCustomList();
              }
              this.page = "";
              this.$router.push({
                name: this.$route.name,
                query: {
                  update:
                    this.$route.query.update || this.$route.query.update == true
                      ? false
                      : true
                }
              });
              //  code for notificatin display
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.status_message,
                type: "success",
                showCloseButton: true
              });
            });
        }
        if (this.page == "update") {
          this.$store
            .dispatch("settings/customfieldupdate", {
              data: data,
              remaining_fields: this.remaining_fields,
              id: this.update_id
            })
            .then(result => {
              if (result.status == 201) {
                //  code for notificatin display
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: result.data.status,
                  type: "danger",
                  showCloseButton: true
                });
                return;
              }
              if (result.status == 200) {
                this.$store.state.permission.cus_settings_details.custom_field =
                  result.data.custom_field;
                this.fetchCustomList();
              }
              this.page = "";
              this.$router.push({
                name: this.$route.name,
                query: {
                  update:
                    this.$route.query.update || this.$route.query.update == true
                      ? false
                      : true
                }
              });
              //  code for notificatin display
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.status_message,
                type: "success",
                showCloseButton: true
              });
            });
        }
      }
    },
    async onSubmit() {
      // await this.removeRoute();
      this.$validator.validateAll().then(result => {
        if (result) {
          //this.field.custom = false;
          this.submitted = true;
          this.settingsdata();
          setTimeout(() => {
            this.submitted = false;
          }, 3000);
        } else {
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    }
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store
      .dispatch("settings/fetchCustomList", {
        stg_menu: "Customer"
      })
      .then(() => {
        next();
      });
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Customer",
        stg_name: "cus_settings_details"
      })
      .then(() => {
        next();
      });
  },
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("settings/fetchCustomList", {
        stg_menu: "Customer"
      })
      .then(() => {
        next();
      });
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Customer",
        stg_name: "cus_settings_details"
      })
      .then(() => {
        next();
      });
  },
  created() {
    this.page = "";
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    if (!this.field.cus_credit_limit) {
      this.field.cus_credit_limit = this.cus_credit_limit;
    }
  },
  computed: {
    page: {
      get() {
        return this.$store.state.settings.page;
      },
      set(val) {
        this.$store.state.settings.page = val;
      }
    },
    ...mapState({
      field: state => state.settings.list["Customer"] || { custom_field: {} },
      list: state => state.settings.list,
      custom_field: state => state.settings.custom_list,
      max_count: state => state.settings.max_count,
      used_count: state => state.settings.used_count,
      message: state => state.settings.delete_message,
      code: state => state.settings.code,
      status_message: state => state.settings.status_message
    }),
    cus_settings_details: {
      get() {
        return this.$store.state.permission.cus_settings_details;
      },
      set(val) {
        this.$store.state.permission.cus_settings_details = val;
      }
    }
  }
};
</script>